module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-content"
  }, [_c('p', [_vm._v("\n    您好，您当前暂时没有Eventplanning Dashboard看板权限。\n    "), _c('br'), _vm._v("\n    若需申请用户权限，请说明个人所在部门，团队请发送申请邮件至：\n    "), _c('br'), _vm._v("\n    zhifeng.wu.zw1@roche.com\n    "), _c('br'), _vm._v("\n    待审批和赋权后即可登录系统\n  ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00377641", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00377641","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/dashboard/error/ErrorSection.vue
// module id = 1545
// module chunks = 7